import { PLANNING_LOOKUP_LINK, PLANNING_LOOKUP_CONFIRM } from '@/constants/planningLookup';

const navigationsHomeDefault = [
    {
        id: "workflows",
        type: "item",
        icon: "nav_ycsb",
        title: "Quy trình",
        image: require('@/assets/icons/YCSB.png'),
        routeName: "workflows.user_task",
        customImage: true,
        have_bought: true,
        incomming: false
    },
    {
        id: "customer",
        type: "item",
        icon: "users",
        title: "Quản lý đối tác",
        image: require('@/assets/icons/QLDT.png'),
        routeName: "customer_group_first.create",
        customImage: false,
        have_bought: true,
        incomming: false,
        dropdown: [
            {
                id: "customer",
                type: "item",
                icon: "users",
                title: "Quản lý đối tác",
                image: require('@/assets/icons/QLDT.png'),
                // routeName: "customer.index",
                dropdown: [
                    {
                        id: "customer_group_first",
                        title: "Phân cấp",
                        routeName: "customer_group_first.create",
                        exact: true
                    },
                    {
                        id: "customer_group",
                        title: "Nhóm đối tác",
                        type: "item",
                        routeName: "customer.index2",
                        exact: true
                    },
                    {
                        id: "customer_private",
                        title: "Đối tác",
                        type: "item",
                        routeName: "customer.index",
                        exact: true
                    },
                ],
                customImage: false
            },
        ],
    },
    {
        id: "tcct",
        type: "item",
        icon: "chart-line",
        title: "Cổng chứng thư",
        image: require('@/assets/icons/TCCT.png'),
        routeName: "certificate_lookup",
        exact: true,
        have_bought: true,
        incomming: false,
    },
    {
        id: "manage",
        type: "item",
        icon: "users-cog",
        title: "Cài đặt công ty",
        image: require('@/assets/icons/QLNB.png'),
        routeName: "staff.index",
        exact: true,
        customImage: false,
        have_bought: true,
        incomming: false,
        dropdown: [
            {
                id: "manage",
                type: "item",
                icon: "users-cog",
                title: "Cài đặt công ty",
                image: require('@/assets/icons/QLNB.png'),
                dropdown: [
                    {
                        id: "staff",
                        type: "item",
                        title: "Tài khoản",
                        routeName: "staff.index",
                        exact: true
                    },
                    {
                        id: "role",
                        type: "item",
                        title: "Phân quyền",
                        routeName: "role.index",
                        exact: true
                    },
					{
						id: "branch",
						title: "Chi nhánh",
						routeName: "branch.index",
						exact: true
					},
					{
						id: "position",
						title: "Chức vụ",
						routeName: "position.index",
						exact: true
					},
					{
						id: "appraiser-company",
						title: "Thông tin công ty",
						routeName: "appraiser-company.index",
						exact: true
                    },
                    {
                        id: "workFlowConfig",
                        title: "SLA",
                        routeName: "pre_certificate_config.index",
                        exact: true
                    },
                    {
                        id: "working-hours",
                        title: "Thời gian làm việc",
                        routeName: "working_hours.index",
                        exact: true
                    }
                ],
                exact: true,
                customImage: false
            },
        ],
    },
    {
        id: "certification_asset",
        type: "item",
        icon: "nav_tstd",
        title: "Thẩm định tài sản",
        image: require('@/assets/icons/TSTD.png'),
        routeName: "certification_asset.index",
        customImage: true,
        have_bought: true,
        incomming: false,
        dropdown: [
            {
                id: "certification_asset",
                type: "item",
                icon: "nav_tstd",
                title: "Thẩm định tài sản",
                image: require('@/assets/icons/TSTD.png'),
                dropdown: [
                    {
                        id: "real_estate",
                        title: "Bất động sản",
                        routeName: "certification_asset.index",
                        exact: true
                    },
                    {
                        id: "personal_property",
                        title: "Động sản",
                        routeName: "certification_personal_property.index",
                        exact: true
                    }
                ],
                customImage: true
            },
        ],
    },
    {
        id: "warehouse",
        type: "item",
        icon: "nav_kg",
        title: "Tài sản so sánh",
        image: require('@/assets/icons/TSSS.png'),
        routeName: "warehouse.index",
        customImage: true,
        have_bought: true,
        incomming: false,
    },
    {
        id: "price_estimates",
        type: "item",
        icon: "nav_utg",
        title: "Định giá sơ bộ",
        image: require('@/assets/icons/TSSB.png'),
        routeName: "price_estimates.index",
        customImage: true,
        have_bought: true,
        incomming: false
    },
    {
        id: "appraise",
        type: "item",
        icon: "nav_dltd",
        title: "Cài đặt nghiệp vụ",
        image: require('@/assets/icons/QLDL.png'),
        routeName: "appraise-law.index",
        customImage: true,
        have_bought: true,
        incomming: false,
        dropdown: [
            {
                id: "appraise",
                type: "item",
                icon: "nav_dltd",
                title: "Cài đặt nghiệp vụ",
                image: require('@/assets/icons/QLDL.png'),
                dropdown: [
                    {
                        id: "appraise-law",
                        title: "Văn bản pháp luật",
                        routeName: "appraise-law.index",
                        exact: true
                    },
                    {
                        id: "appraise-other",
                        title: "Cơ sở thẩm định",
                        routeName: "appraise-other.index",
                        exact: true
                    },
                    {
                        id: "appraisal-construction",
                        title: "Công ty xây dựng",
                        routeName: "appraisal-construction.index",
                        exact: true
                    },
                    {
                        id: "building",
                        title: "Loại công trình",
                        routeName: "building.index",
                        exact: true
                    },
                    {
                        id: "element",
                        title: "Yếu tố so sánh",
                        routeName: "element.index",
                        exact: true
                    },
                    {
                        id: "dictionary",
                        title: "Đặc điểm tài sản",
                        routeName: "dictionary.index",
                        exact: true
                    },
                    {
                        id: "province",
                        title: "Tỉnh/Thành",
                        routeName: "province.index",
                        exact: true
                    },
                    {
                        id: "district",
                        title: "Quận/Huyện",
                        routeName: "district.index",
                        exact: true
                    },
                    {
                        id: "ward",
                        title: "Phường/Xã",
                        routeName: "ward.index",
                        exact: true
                    },
                    {
                        id: "street",
                        title: "Đường phố",
                        routeName: "street.index",
                        exact: true
                    },
                    {
                        id: "distance",
                        title: "Đoạn đường",
                        routeName: "distance.index",
                        exact: true
                    },
                    {
                        id: "apartment",
                        title: "Chung cư",
                        routeName: "apartment.index",
                        exact: true
                    }
                ],
                customImage: true
            },
        ],
    },
    {
        id: "map",
        type: "item",
        icon: "nav_bdg",
        title: "Bản đồ giá",
        image: require('@/assets/icons/BDG.png'),
        routeName: "map.index",
        exact: true,
        customImage: true,
        have_bought: true,
        incomming: false,
    },
    {
        id: "quyhoach",
        type: "item",
        icon: "nav_bddc",
        title: "Tra quy hoạch",
        image: require('@/assets/icons/TCQH.png'),
        externalLink: PLANNING_LOOKUP_LINK,
        confirmMessage: PLANNING_LOOKUP_CONFIRM,
        customImage: true,
        have_bought: true,
        incomming: false,
    },
    {
        id: "tttt",
        type: "item",
        icon: "nav_bdg",
        title: "Thị trường",
        image: require('@/assets/icons/TTTT_incomming.png'),
        routeName: "map.index",
        exact: true,
        customImage: true,
        have_bought: true,
        incomming: true,
    },
    {
        id: "finance",
        type: "item",
        icon: "chart-line",
        title: "Công cụ tài chính",
        image: require('@/assets/icons/financial-tools.png'),
        routeName: "finance.index",
        exact: true,
        have_bought: true,
        incomming: false,
    },
    {
        id: "dashboard",
        type: "item",
        icon: "chart-line",
        title: "Báo cáo quản trị",
        image: require('@/assets/icons/BCQT.png'),
        routeName: "dashboard.index",
        exact: true,
        have_bought: true,
        incomming: false,
    },
];
let navigationsHome = [];
if (process.env.navigations && process.env.navigations.home && process.env.navigations.home.length > 0) {
	for (let index = 0; index < navigationsHomeDefault.length; index++) {
		const element = navigationsHomeDefault[index];
		if (process.env.navigations.home.includes(element.id)) {
			navigationsHome.push(element);
		}
	}
} else {
	navigationsHome = navigationsHomeDefault;
}
export { navigationsHome };
